// Payment Success Page Component
// File: src/jsx/components/Common/PaymentSuccessPage.jsx

import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../../../src/assets/images/logo.png"
const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [paymentData, setPaymentData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log("🎉 PaymentSuccessPage component rendered");
    console.log("📍 Location:", location);

    // Parse URL parameters - including ALL initiateSale parameters
    const urlParams = new URLSearchParams(location.search);

    // Payment gateway response parameters
    const acqID = urlParams.get("acqID");
    const transactionNumber = urlParams.get("transactionNumber");
    const amount = urlParams.get("amount");
    const responseCode = urlParams.get("responseCode");
    const txnID = urlParams.get("txnID");
    const paymentDateTime = urlParams.get("paymentDateTime");
    const customerEmailID = urlParams.get("customerEmailID");
    const customerMobileNo = urlParams.get("customerMobileNo");
    const merchantId = urlParams.get("merchantId");
    const paymentMode = urlParams.get("paymentMode");

    // ✅ ALL initiateSale parameters
    const patient_id = urlParams.get("patient_id");
    const appointment_id = urlParams.get("appointment_id");
    const lead_id = urlParams.get("lead_id");
    const prescription_id = urlParams.get("prescription_id");
    const queue_id = urlParams.get("queue_id");
    const payment_for = urlParams.get("payment_for");
    const payment_type = urlParams.get("payment_type");
    const customer_name = urlParams.get("customer_name");
    const customer_email = urlParams.get("customer_email");
    const customer_mobile = urlParams.get("customer_mobile");
    const customer_address = urlParams.get("customer_address");
    const description = urlParams.get("description");
    const reference_id = urlParams.get("reference_id");

    // Create payment data object with ALL parameters
    const data = {
      // Payment gateway response parameters
      acqID: acqID || "",
      transactionNumber: transactionNumber || "",
      amount: amount || "",
      responseCode: responseCode || "",
      txnID: txnID || "",
      paymentDateTime: paymentDateTime || "",
      customerEmailID: customerEmailID || "",
      customerMobileNo: customerMobileNo || "",
      merchantId: merchantId || "",
      paymentMode: paymentMode || "",

      // ✅ ALL initiateSale parameters
      patient_id: patient_id || "",
      appointment_id: appointment_id || "",
      lead_id: lead_id || "",
      prescription_id: prescription_id || "",
      queue_id: queue_id || "",
      payment_for: payment_for || "",
      payment_type: payment_type || "",
      customer_name: customer_name || "",
      customer_email: customer_email || "",
      customer_mobile: customer_mobile || "",
      customer_address: customer_address || "",
      description: description || "",
      reference_id: reference_id || "",

      status: "SUCCESS",
      message: "Payment completed successfully!",
      timestamp: new Date().toISOString(),
    };

    console.log("🎉 PaymentSuccessPage - Received ALL initiateSale parameters:", data);

    setPaymentData(data);
    setIsLoading(false);

    // Show success toast
    toast.success("Payment completed successfully!");

    // Clear any stored payment data
    localStorage.removeItem("currentPayment");
  }, [location]);

  const handleBackToApp = () => {
    navigate("/");
  };

  const handleViewReceipt = () => {
    // Generate a comprehensive receipt with ALL initiateSale parameters
    const receipt = `
      Payment Receipt
      ================
      Transaction: ${paymentData?.transactionNumber}
      Amount: ₹${paymentData?.amount}
      Date: ${new Date().toLocaleString()}
      Status: ${paymentData?.status}
      Bank Txn ID: ${paymentData?.txnID}
      
      Patient Details:
      ================
      Patient ID: ${paymentData?.patient_id}
      Customer Name: ${paymentData?.customer_name}
      Customer Email: ${paymentData?.customer_email}
      Customer Mobile: ${paymentData?.customer_mobile}
      Customer Address: ${paymentData?.customer_address}
      
      Payment Details:
      ================
      Payment For: ${paymentData?.payment_for}
      Payment Type: ${paymentData?.payment_type}
      Description: ${paymentData?.description}
      
      Reference IDs:
      ================
      Appointment ID: ${paymentData?.appointment_id}
      Lead ID: ${paymentData?.lead_id}
      Prescription ID: ${paymentData?.prescription_id}
      Queue ID: ${paymentData?.queue_id}
      Reference ID: ${paymentData?.reference_id}
    `;

    console.log("🧾 Comprehensive Receipt with ALL initiateSale parameters:", receipt);
    toast.info("Comprehensive receipt generated! Check console for details.");
  };

  if (isLoading) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body text-center">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading payment success details...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card border-success">
            <div className="card-header bg-success text-white">
              <h4 className="mb-0">🎉 Payment Successful!</h4>
       
            </div>
         
            <div className="card-body">
            <div className="position-relative mb-4 text-center">
  {/* Right side logo */}
  <img
    src={logo}
    alt="logo"
    style={{
      position: "absolute",
      top: "0",
      right: "0",
      height: "70px",
      width: "auto",
      objectFit: "contain",
    }}
  />

  {/* Success Icon */}
  <div className="display-1 text-success mb-3">✅</div>

  <h2 className="text-success mb-3">
    Payment Completed Successfully!
  </h2>

  <p className="lead">
    Your transaction has been processed successfully.
  </p>
</div>

              {paymentData && (
                <div className="row justify-content-center">
                  <div className="col-md-8">
                    <div className="card border-0 shadow-sm">
                      <div className="card-body text-center p-4">
                        <div className="row">
                          <div className="col-md-6">
                            <h6 className="text-muted mb-3">
                              Transaction Details
                            </h6>
                            <div className="mb-3">
                              <small className="text-muted">
                                Transaction ID
                              </small>
                              <div className="fw-bold">
                                {paymentData.transactionNumber || "N/A"}
                              </div>
                            </div>
                            <div className="mb-3">
                              <small className="text-muted">Amount</small>
                              <div className="h5 text-success fw-bold">
                                ₹{paymentData.amount || "0.00"}
                              </div>
                            </div>
                            <div className="mb-3">
                              <small className="text-muted">Payment Mode</small>
                              <div className="fw-bold">
                                {paymentData.paymentMode || "N/A"}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <h6 className="text-muted mb-3">
                              Payment Information
                            </h6>
                            <div className="mb-3">
                              <small className="text-muted">
                                Bank Transaction ID
                              </small>
                              <div className="fw-bold">
                                {paymentData.txnID || "N/A"}
                              </div>
                            </div>
                            <div className="mb-3">
                              <small className="text-muted">Date & Time</small>
                              <div className="fw-bold">
                                {(() => {
                                  const now = new Date();
                                  const date = now.toLocaleDateString("en-GB").replace(/\//g, "-"); // 12-02-2025
                                  const time = now.toLocaleTimeString("en-GB", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  }); // 14:30
                                  return `${date}, ${time}`;
                                })()}
                              </div>
                            </div>
                            <div className="mb-3">
                              <small className="text-muted">Status</small>
                              <div>
                                <span className="badge bg-success">
                                  {paymentData.status}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="alert alert-success mt-4">
                <h6>What happens next?</h6>
                <ul className="mb-0">
                  <li>Your payment has been confirmed</li>
                  <li>You will receive a confirmation email</li>
                  <li>Your booking/appointment is now confirmed</li>
                  <li>Now you can close window</li>
                </ul>
              </div>

              <div className="text-center mt-4">
                {/* <button
                  className="btn btn-success btn-lg me-3"
                  onClick={handleViewReceipt}
                >
                  📄 View Receipt
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
